<mat-tab-group mat-align-tabs="center" class="full-width" (selectedTabChange)="tabHasChanged($event)" [(selectedIndex)]="defaultTabIndex">
  <mat-tab label="Transfert de responsabilité CAC" [disabled]="!isUserCacOnAtLeastOneOuvrage">
  	<transfert-configurator [refreshCommands]="refreshCacTabCommand"  ></transfert-configurator>
  </mat-tab>
  <mat-tab label="Transfert de responsabilité CC" [disabled]="!isUserCcOnAtLeastOneOuvrage">
  	<transfert-configurator [refreshCommands]="refreshCcTabCommand"  ></transfert-configurator>  
  </mat-tab>
</mat-tab-group>